import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

const GameContext = createContext();

const DB_TABLE = "skzmalang";
const PLAYER_NAME = "PLAYER_NAME";
const PLAYER_KEY_CODE = "PLAYER_KEY_CODE";

export function GameProvider({ children }) {
  const location = useLocation();

  // 단서 개수
  const [MISSION_TOTAL, setMissionTotal] = useState(() => {
    return Number(localStorage.getItem("missionTotal")) || 1;
  });

  /* =========================
    이름 (유지)
  ========================= */
  const [playerName, setPlayerName] = useState(() => {
    return localStorage.getItem(PLAYER_NAME) || "";
  });

  useEffect(() => {
    if (playerName) {
      localStorage.setItem(PLAYER_NAME, playerName);
    }
  }, [playerName]);

  /* =========================
    🔑 keyCode (ADD)
  ========================= */
  const [playerKeyCode, setPlayerKeyCode] = useState(() => {
    return localStorage.getItem(PLAYER_KEY_CODE) || "";
  });

  useEffect(() => {
    if (playerKeyCode) {
      localStorage.setItem(PLAYER_KEY_CODE, playerKeyCode);
    }
  }, [playerKeyCode]);

  /* =========================
     루트(/) 진입 시 전체 초기화
  ========================= */
  useEffect(() => {
    if (location.pathname === "/") {
      setPlayerName("");
      setPlayerKeyCode("");
      setClearedStages(new Set());
      localStorage.removeItem(PLAYER_NAME);
      localStorage.removeItem(PLAYER_KEY_CODE);
      localStorage.removeItem("gameUserId");
      localStorage.removeItem("correctCount");
      localStorage.removeItem("suspectScore");
      localStorage.removeItem("missionTotal");
    }
  }, [location.pathname]);

  /* =========================
     스테이지 / 미션 (기존 유지)
  ========================= */
  const [clearedStages, setClearedStages] = useState(() => {
    const saved = localStorage.getItem("clearedStages");
    return saved ? new Set(JSON.parse(saved)) : new Set();
  });

  useEffect(() => {
    localStorage.setItem("clearedStages", JSON.stringify([...clearedStages]));
  }, [clearedStages]);

  const clearStageOnce = (stageKey) => {
    if (!stageKey) return;

    setClearedStages((prev) => {
      if (prev.has(stageKey)) return prev;

      const next = new Set(prev);
      next.add(stageKey);

      // console.log(
      //   "Current Stage:",
      //   stageKey,
      //   ", Total Cleared:",
      //   next.size,
      //   "Cleared Stages:",
      //   next,
      // );

      return next;
    });
  };

  const increaseMissionOnce = (missionKey) => {
    clearStageOnce(missionKey);
  };

  // clearedStages 초기화 함수
  const resetClearedStages = () => {
    setClearedStages(new Set());
    localStorage.removeItem("clearedStages");
  };

  const initStage1 = () => {
    resetClearedStages();
    setMissionTotal(3);
    localStorage.setItem("missionTotal", 3);
  };

  /*
  {{playerName}} 같은 템플릿 변수를 치환하는 함수
  - 사용 구문 1 : {interpolate(c.chat_tit, { playerName })}
  - 사용 구문 2 : 
    const variables = { 
      playerName: "홍길동",
      playerAge: 25,
    };
    {interpolate(c.chat_tit, variables)}
  */
  const interpolate = (text, variables) => {
    if (!text) return text;

    return text.replace(
      /\{\{(\w+)\}\}/g,
      (_, key) => variables[key] ?? `{{${key}}}`,
    );
  };

  return (
    <GameContext.Provider
      value={{
        DB_TABLE,

        playerName,
        setPlayerName,

        playerKeyCode,
        setPlayerKeyCode,

        MISSION_TOTAL,
        clearedStages,
        increaseMissionOnce,
        initStage1,

        interpolate,
      }}
    >
      {children}
    </GameContext.Provider>
  );
}

export const useGame = () => useContext(GameContext);
